import { Fragment } from 'react';
import { cardSrc, parsePokerCards, parsePokerRdesc } from './resultParsers';

export default function PokerResult({ detail, gameType }) {
  // 20-20 Poker: REF shows one "Other:" row; Poker 1-Day keeps "2 Card:" + "7 Card:".
  const is20 = gameType === 'poker20';
  const cards = parsePokerCards(detail?.card);
  const rdesc = parsePokerRdesc(detail?.rdesc);

  return (
    <div className="row row5">
      <div className="col-12 col-lg-5">
        <div className="casino-result-content mt-0">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {detail?.win === '1' && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Player A</h4>
                {cards.playerA.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="casino-result-content-diveder"></div>
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {detail?.win === '2' && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Player B</h4>
                {cards.playerB.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4 d-flex align-items-center">
        <div className="casino-result-cards d-block w-100">
          <div className="text-center">
            <h4 className="text-center">Board</h4>
            {cards.board.map((code, i) => (
              <Fragment key={i}>
                {' '}
                <div className="casino-result-cards-item">
                  <img src={cardSrc(code)} alt={code} />
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-3">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Main:</div>
            {/* 20-20 Poker drawn round: blank, as on the reference (no "-") */}
            <div>{detail?.winnat || rdesc.winner || (is20 ? '' : '-')}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>{is20 ? 'Other:' : '2 Card:'}</div>
            <div>{rdesc.card2 || (is20 ? '' : '-')}</div>
          </div>
          {!is20 && (
            <div className="casino-result-desc-item">
              <div>7 Card:</div>
              <div>{rdesc.card7 || '-'}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
